/* eslint-disable no-undef */
import React, { useEffect, } from "react";
import { Route, Routes } from "react-router-dom";
import { RoutesPage, RoutesAuth, RoutesUser, routeArr } from "../Route/route";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import UserHeader from "../Component/UserHeader";
import { useDispatch, useSelector } from "react-redux";
import NotFound from "../Component/NotFound";
import { ToastContainer } from "react-toastify";
import { fetchMaintenanceSettings, setShowMarquee } from "./Slice/pageSlice";
import PropTypes from "prop-types";
import { useCleanUrl } from "../utils/helpers";

const RouteWithValidation = ({ element: Element }) => {
  useCleanUrl();
  const url = globalThis.location.href;

  return (
    <>
      {!url.includes("olay-stem-mentoring") && <Header />}
      {Element}
      {!url.includes("olay-stem-mentoring") && <Footer />}
    </>
  );
};

RouteWithValidation.propTypes = {
  element: PropTypes.node.isRequired
};

const RouteWithHeader = ({ element: Element }) => {
  useCleanUrl();
  const url = globalThis.location.href;

  return (
    <>
      {!url.includes("olay-stem-mentoring") && <Header />}
      {Element}
      {!url.includes("olay-stem-mentoring") && <Footer />}
    </>
  );
};

RouteWithHeader.propTypes = {
  element: PropTypes.node.isRequired
};

const RouteWithAuth = ({ element: Element }) => {
  useCleanUrl();
  const url = globalThis.location.href;
  const isLoginPage = globalThis.location.pathname === "/login";

  return (
    <>
      {!url.includes("olay-stem-mentoring") && <Header />}
      {Element}
      {!url.includes("olay-stem-mentoring") && !isLoginPage && <Footer />}
    </>
  );
};

RouteWithAuth.propTypes = {
  element: PropTypes.node.isRequired
};

const RouteWithSidebar = ({ element: Element, title }) => {
  useCleanUrl();

  return (
    <div className="main-body">
      <div className="page-wrapper">
        <UserHeader title={title} />
        {Element}
      </div>
    </div>
  );
};

RouteWithSidebar.propTypes = {
  element: PropTypes.node.isRequired,
  title: PropTypes.string,
};

const Index = (props) => {
  const dispatch = useDispatch();

  const { setting, showMarquee } = useSelector((state) => state?.page);


  useEffect(() => {
    dispatch(fetchMaintenanceSettings());
  }, [dispatch]);

  useEffect(() => {
    if (!setting.site_maintenance_notification) {
      dispatch(setShowMarquee(false));
      return;
    }

    const now = new Date();
    const from = new Date(setting.start_date_time);
    const to = new Date(setting.end_date_time);

    const shouldShow =
      now >= from && now <= to && !!setting.notification_message;

    dispatch(setShowMarquee(shouldShow));
  }, [setting, dispatch]);


  return (
    <>
      {showMarquee && (
        <div className="marquee-wrapper">
          <div
            style={{
              background: "#f0f8ff",
              whiteSpace: "nowrap",
              overflow: "hidden",
              fontWeight: "bold",
              padding: "10px",
              color: "#000",
            }}
          >
            <div
              className="marquee-text"
            >
              {setting.notification_message}
            </div>
            <style>{`
            @keyframes marquee {
              0% { transform: translateX(100%) }
              100% { transform: translateX(-100%) }
            }
          `}</style>
          </div>
        </div>
      )}
      <ToastContainer />

      {/* ✅ Routes */}
      <Routes>

        {RoutesPage.map((route, index) => {
          let Element = <route.component title={route?.title || ""} />; // uppercase JSX
          return (
            <Route
              key={route.path}
              path={route.path}
              element={<RouteWithHeader element={Element} title={route?.title || ""} />}
            />
          );
        })}

        {RoutesAuth.map((route, index) => {
          let Element = <route.component title={route?.title || ""} />; // uppercase JSX
          return (
            <Route
              key={route.path}
              path={route.path}
              element={<RouteWithAuth element={Element} title={route?.title || ""} />}
            />
          );
        })}

        {routeArr.map((route, index) => {
          let Element = <route.component title={route?.title || ""} />; // uppercase JSX
          return (
            <Route
              key={route.path}
              path={route.path}
              element={<RouteWithValidation element={Element} title={route?.title || ""} />}
            />
          );
        })}

        {RoutesUser.map((route, index) => {
          let Element = <route.component title={route?.title || ""} />; // uppercase JSX
          return (
            <Route
              key={route.path}
              path={route.path}
              element={<RouteWithSidebar element={Element} title={route?.title || ""} />}
            />
          );
        })}

        <Route
          path="*"
          element={<RouteWithHeader element={<NotFound />} title="Not Found" />}
        />

      </Routes>
    </>
  );
};

export default Index;
